// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-header {
  display: flex;
  flex-direction: row;
  cursor: default;
  left: 0;
}
.form-header mat-chip-list {
  padding: 0;
}
.form-header mat-chip-list .mat-standard-chip {
  top: -11px;
  font-size: 11px;
  min-height: 10px;
}

::ng-deep .form-header .mat-chip-list-wrapper {
  position: absolute;
}

.editable {
  display: flex;
  padding: 4px;
  width: 1115px;
  font-size: 25px;
  color: grey;
  margin-right: auto;
  border: none;
  outline: none;
  background: transparent;
}

.editable:hover {
  background-color: wheat;
}

.editable-new {
  display: flex;
  padding: 4px;
  min-width: 230px;
  max-width: 900px;
  font-size: 25px;
  color: grey;
  margin-right: auto;
  border: none;
  outline: none;
  background: transparent;
}

.editable-new:hover,
.editable-new:focus,
#formNameNew:hover,
#formNameNew:focus {
  background-color: transparent !important;
  box-shadow: none !important;
}

.editable-new:hover {
  background-color: wheat;
}

@media (min-width: 0px) and (max-width: 330px) {
  .editable-new {
    max-width: 200px;
  }
}
@media (min-width: 330px) and (max-width: 375px) {
  .editable-new {
    min-width: 230px;
  }
}
@media (min-width: 375px) and (max-width: 500px) {
  .editable-new {
    min-width: 245px;
  }
}
@media (min-width: 500px) and (max-width: 667px) {
  .editable-new {
    min-width: 380px;
  }
}
@media (min-width: 667px) and (max-width: 730px) {
  .editable-new {
    min-width: 460px;
  }
}
@media (min-width: 730px) and (max-width: 812px) {
  .editable-new {
    min-width: 520px;
  }
}
@media (min-width: 812px) and (max-width: 1024px) {
  .editable-new {
    min-width: 560px;
  }
}
@media (min-width: 1024px) and (max-width: 1128px) {
  .editable-new {
    min-width: 730px;
  }
}
@media (min-width: 1128px) and (max-width: 1200px) {
  .editable-new {
    min-width: 820px;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .editable-new {
    min-width: 900px;
  }
}
@media (min-width: 1300px) and (max-width: 1360px) {
  .editable-new-eform {
    min-width: 950px;
  }
}
@media (min-width: 1360px) {
  .editable-new {
    min-width: 1145px;
  }
}
.form-setting {
  display: flex;
}
.form-setting mat-icon {
  margin-right: 5px;
  cursor: pointer;
  margin-top: 2.5px;
}

.form-body {
  padding-bottom: 10px;
}

.f-create {
  width: 1150px;
  height: calc(100vh - 120px);
  margin-left: 20px;
}

.f-control {
  display: flex;
}

.drag-placeholder-section {
  background: grey;
  border: dotted 4px black;
  min-height: 94px;
  width: 1147px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.drag-placeholder-field {
  background: rgba(0, 0, 0, 0.12);
  border: dotted 4px #999;
  min-height: 94px;
  width: 100px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.click-active {
  background: #bad9e8;
  border-radius: 0.5em;
}

.mat-divider {
  border-top-width: 2px;
  border-top-style: solid;
  margin: 0px 5px 0px 0px;
}

.new-field {
  font-size: 25px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  border-width: 1px;
  border-style: dashed;
  border-radius: 0.5em;
  height: 35px;
}

.new-field .field .new-table {
  border-radius: unset !important;
}

.new-section {
  font-size: 30px;
  text-align: center;
  justify-content: center;
  flex-direction: column-reverse;
  height: 62px;
}

.btn-strip {
  opacity: 1;
  top: 400px;
  position: sticky;
  padding: 0;
  left: 0;
  right: 0;
  width: 0px;
}
.btn-strip button {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.btn-strip button .mat-icon {
  color: grey;
  border-radius: 50%;
  position: absolute;
  left: -5px;
}
.btn-strip button :hover {
  background-color: rgb(255, 255, 255);
}

.mat-spinner {
  position: fixed;
  margin-left: 50%;
  margin-right: 50%;
  top: 50%;
}

.load-spinner {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: wait;
}

.section-preview, .field-preview {
  max-width: 250px;
}
.section-preview button, .field-preview button {
  text-align: left;
  max-width: 250px;
  background-color: wheat;
  color: grey;
}
.section-preview button .inner-preview, .field-preview button .inner-preview {
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid wheat;
}
.section-preview button .inner-preview mat-icon, .field-preview button .inner-preview mat-icon {
  vertical-align: middle;
  margin: 0.2em;
}

.cdk-drop-list-dragging {
  background-color: wheat;
  opacity: 0.5;
  border-radius: 0.5em;
}

.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.form-valid {
  border: 1px solid salmon;
  border-radius: 0.5em;
}

.error-tooltip {
  position: absolute;
  margin: -4.5px;
  color: red;
}
.error-tooltip mat-icon {
  margin: -10px;
}

.hide-load {
  visibility: hidden;
}

.field-container {
  pointer-events: none;
  display: flex;
  flex-direction: column;
}
.field-container label {
  font-size: 11px;
  padding: 1px 10px 1px 10px;
}

.field-container-f-table {
  display: flex;
  flex-direction: column;
}
.field-container-f-table label {
  font-size: 11px;
  padding: 1px 10px 1px 10px;
}

.space-pre {
  white-space: pre-wrap;
}

.space-break {
  word-break: break-all;
  white-space: break-spaces;
}

:host .mat-menu-panel {
  min-height: 0px;
  min-width: 0px;
}
:host .mat-menu-panel .mat-menu-content {
  padding-top: 0;
  padding-bottom: 0;
}
:host .mat-menu-panel .mat-menu-item {
  width: auto;
}

.content-style {
  display: flex;
}

.input-label {
  font-size: 11px;
  padding: 10px 10px 1px 10px;
}

.menu-item button {
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  padding: 4px !important;
}
.menu-item button mat-icon {
  margin: 0px !important;
  font-size: 18px;
}
.menu-item button span {
  margin-top: -13px;
  margin-bottom: -13px;
  font-size: 10px;
}

.signature {
  margin-bottom: 7.7px;
}
.signature img {
  max-height: 50px;
  max-width: 220px;
}

.cut-active {
  background: #bad9e8;
  border-radius: 0.5em;
  opacity: 0.5;
}

.always-right {
  text-align: right;
}

::ng-deep .choice-field-body .mat-form-field-label {
  font-size: 14px !important;
}

::ng-deep .choice-field-body .mat-form-field-flex {
  width: 95%;
  margin-left: 2%;
}

.choice-field-body-table {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: auto;
  word-wrap: break-word;
}
.choice-field-body-table .mat-form-field {
  font-size: 14px;
}
.choice-field-body-table select {
  height: 22px;
  cursor: move;
}
.choice-field-body-table select:disabled {
  border-width: 1px;
  border-color: rgba(118, 118, 118, 0.3);
  background: #f8f8f8;
  border-radius: 2px;
  border-style: groove;
}
.choice-field-body-table .mat-form-field-appearance-outline .mat-form-field-outline {
  color: rgba(118, 118, 118, 0.3);
  border-radius: 5px;
}
.choice-field-body-table .choice-layout-0, .choice-field-body-table .choice-layout-1 {
  margin: 0px 1px 7.5px 10px !important;
  overflow: hidden;
}
.choice-field-body-table .choice-layout-0 .mat-radio-button ~ .mat-radio-button, .choice-field-body-table .choice-layout-1 .mat-radio-button ~ .mat-radio-button {
  margin-right: 20px;
}
.choice-field-body-table .choice-layout-0 .mat-radio-button:first-child, .choice-field-body-table .choice-layout-1 .mat-radio-button:first-child {
  margin-right: 20px;
}
.choice-field-body-table .choice-layout-0 .mat-radio-container, .choice-field-body-table .choice-layout-1 .mat-radio-container {
  align-self: start;
}
.choice-field-body-table .choice-layout-0 .mat-radio-disabled, .choice-field-body-table .choice-layout-0 .mat-radio-disabled .mat-radio-label, .choice-field-body-table .choice-layout-1 .mat-radio-disabled, .choice-field-body-table .choice-layout-1 .mat-radio-disabled .mat-radio-label {
  cursor: move;
  margin-top: 0.25px;
}
.choice-field-body-table .choice-layout-0 .mat-radio-outer-circle, .choice-field-body-table .choice-layout-1 .mat-radio-outer-circle {
  height: 18px !important;
  width: 18px !important;
  top: 3px !important;
  border-width: 1px !important;
}
.choice-field-body-table .choice-layout-0 .mat-radio-inner-circle, .choice-field-body-table .choice-layout-1 .mat-radio-inner-circle {
  height: 18px !important;
  width: 18px !important;
  top: 3px !important;
}
.choice-field-body-table .choice-layout-0 .mat-radio-button.mat-radio-disabled .mat-radio-label-content, .choice-field-body-table .choice-layout-1 .mat-radio-button.mat-radio-disabled .mat-radio-label-content {
  color: rgba(0, 0, 0, 0.54);
  padding-left: 8px;
  margin-top: 2px;
  word-break: break-all;
}
.choice-field-body-table .choice-layout-0 .mat-checkbox-inner-container, .choice-field-body-table .choice-layout-1 .mat-checkbox-inner-container {
  margin-right: 0px !important;
  margin-top: 5px;
}
.choice-field-body-table .choice-layout-0 .mat-radio-label, .choice-field-body-table .choice-layout-1 .mat-radio-label {
  white-space: normal !important;
  margin-bottom: 5px;
}
.choice-field-body-table .choice-layout-0 .mat-checkbox-layout, .choice-field-body-table .choice-layout-1 .mat-checkbox-layout {
  white-space: normal !important;
  margin: 1px;
  cursor: move;
  margin-top: -1px;
}
.choice-field-body-table .choice-layout-0 .mat-checkbox ~ .mat-checkbox, .choice-field-body-table .choice-layout-1 .mat-checkbox ~ .mat-checkbox {
  margin-right: 20px;
}
.choice-field-body-table .choice-layout-0 .mat-checkbox:first-child, .choice-field-body-table .choice-layout-1 .mat-checkbox:first-child {
  margin-right: 20px;
}
.choice-field-body-table .choice-layout-0 .mat-checkbox-label, .choice-field-body-table .choice-layout-1 .mat-checkbox-label {
  margin-top: 3px;
  word-break: break-all;
  padding-left: 10.5px;
  margin-bottom: 5px;
  line-height: inherit;
}
.choice-field-body-table .choice-layout-1 {
  display: flex;
  flex-direction: column;
}
.choice-field-body-table .choice-layout-1 .mat-radio-group {
  display: flex;
  flex-direction: column;
}
.choice-field-body-table .choice-layout-1 section {
  display: flex;
  flex-direction: column;
}
.choice-field-body-table .choice-layout-1 section .mat-checkbox-disabled {
  cursor: move;
}
.choice-field-body-table .choice-box-field-three .mat-radio-button.mat-radio-disabled .mat-radio-label-content {
  max-width: 327px;
}
.choice-field-body-table .choice-box-field-three .mat-checkbox-label {
  max-width: 309px;
}
.choice-field-body-table .choice-box-field-two .mat-radio-button.mat-radio-disabled .mat-radio-label-content {
  max-width: 510px;
}
.choice-field-body-table .choice-box-field-two .mat-checkbox-label {
  max-width: 500px;
}

.f-table {
  border-radius: unset !important;
  width: 250px !important;
  flex: 0 0 25%;
}

.div-table {
  margin-bottom: 10px;
  padding-right: 12px;
}

.new-table {
  border-radius: unset !important;
  margin-top: 18px !important;
  height: 22px !important;
}

.space-break {
  color: #88808D;
}

.field-table {
  font-size: 25px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  border-width: 1px;
  border-radius: 0.5em;
  height: 60px;
  color: #b2b2b8;
}

.field-table > .field-set {
  width: 100%;
  height: 100%;
}

.field-header-table {
  min-height: 17px;
  margin: 5px 5px 1px 2px;
}

.t-table {
  border-radius: unset !important;
  width: 25%;
}

.table-few {
  border-radius: unset !important;
  width: 33.3333333333%;
}

.table-4 {
  border-radius: unset !important;
  width: 20%;
}

.table-5 {
  border-radius: unset !important;
  width: 16.6666666667%;
}

.table-6 {
  border-radius: unset !important;
  width: 14.2857142857%;
}

.table-7 {
  border-radius: unset !important;
  width: 12.5%;
}

.table-8 {
  border-radius: unset !important;
  width: 11.1111111111%;
}

.table-9 {
  border-radius: unset !important;
  width: 10%;
}

.name-field-body {
  overflow: hidden !important;
}

.input-table {
  height: 22px;
  margin-right: -1px;
}

.div-plus {
  width: 100px;
}

.div-maxTable {
  height: 75px;
}

.text-number {
  text-align: left;
  margin-left: 3px;
  font-size: 11px;
  float: left;
  color: #88808D;
  margin-top: 5px;
}

.max-head-table {
  margin-top: 10px;
}

.field-plus {
  margin-bottom: 16px;
}

.style-left {
  float: left;
}

.over-table:hover {
  background: #F2F2F2;
}

.click-active-table {
  background: #bad9e8;
  border-radius: 0.5em;
}

.radio-field-body-table {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: auto;
  word-wrap: break-word;
}
.radio-field-body-table .mat-form-field {
  font-size: 14px;
}
.radio-field-body-table select {
  height: 22px;
  cursor: move;
}
.radio-field-body-table select:disabled {
  border-width: 1px;
  border-color: rgba(118, 118, 118, 0.3);
  background: #f8f8f8;
  border-radius: 2px;
  border-style: groove;
}

.radio-field-body {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: auto;
  word-wrap: break-word;
  z-index: 0;
}
.radio-field-body select {
  margin: 0px 10px 10px 10px !important;
  height: 23px;
  cursor: move;
}
.radio-field-body select:disabled {
  border-width: 1px;
  border-color: rgba(118, 118, 118, 0.3);
  background: #f8f8f8;
  border-radius: 2px;
  border-style: groove;
}
.radio-field-body .mat-radio-button ~ .mat-radio-button {
  margin-left: 20px;
}
.radio-field-body .mat-radio-button.mat-radio-disabled .mat-radio-label-content {
  color: rgba(0, 0, 0, 0.54);
}
.radio-field-body .mat-radio-outer-circle {
  height: 18px !important;
  width: 18px !important;
  top: 3px !important;
  border-width: 1px !important;
}
.radio-field-body .mat-radio-inner-circle {
  height: 18px !important;
  width: 18px !important;
  top: 3px !important;
}
.radio-field-body .mat-checkbox-layout {
  margin-top: -1px;
}
.radio-field-body .radio-body {
  margin: 0px 1px 10px 10px !important;
  cursor: move;
}
.radio-field-body .radio-slide {
  margin-top: -1px;
}
.radio-field-body .radio-body-1 {
  margin: 0px 10px 10px 10px !important;
  cursor: move;
}
.radio-field-body .radio-body-1 .mat-radio-disabled,
.radio-field-body .radio-body-1 .mat-radio-disabled .mat-radio-label {
  cursor: move;
  margin-top: -1px;
  padding: 1.2px;
  padding-left: 0px;
  padding-right: 0px;
}
.radio-field-body .ct {
  justify-content: center !important;
}

.name-field-body .field-header-table {
  font-size: 14px !important;
  margin: 5px 5px 1px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-create/form-create.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;AACH;AACG;EACG,UAAA;AACN;AACM;EACG,UAAA;EACA,eAAA;EACA,gBAAA;AACT;;AAIA;EACG,kBAAA;AADH;;AAIA;EACG,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AADH;;AAIA;EACG,uBAAA;AADH;;AAIA;EACG,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AADH;;AAIA;;;;EAIG,wCAAA;EACA,2BAAA;AADH;;AAIA;EACG,uBAAA;AADH;;AAIA;EACG;IACG,gBAAA;EADJ;AACF;AAIA;EACG;IACG,gBAAA;EAFJ;AACF;AAKA;EACG;IACG,gBAAA;EAHJ;AACF;AAMA;EACG;IACG,gBAAA;EAJJ;AACF;AAOA;EACG;IACG,gBAAA;EALJ;AACF;AAQA;EACG;IACG,gBAAA;EANJ;AACF;AASA;EACG;IACG,gBAAA;EAPJ;AACF;AAUA;EACG;IACG,gBAAA;EARJ;AACF;AAWA;EACG;IACG,gBAAA;EATJ;AACF;AAYA;EACG;IACG,gBAAA;EAVJ;AACF;AAaA;EACG;IACG,gBAAA;EAXJ;AACF;AAcA;EACG;IACG,iBAAA;EAZJ;AACF;AAeA;EACG,aAAA;AAbH;AAeG;EACG,iBAAA;EACA,eAAA;EACA,iBAAA;AAbN;;AAiBA;EAEG,oBAAA;AAfH;;AAkBA;EACG,aAAA;EACA,2BAAA;EACA,iBAAA;AAfH;;AAkBA;EACG,aAAA;AAfH;;AAkBA;EACG,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,sDAAA;AAfH;;AAkBA;EACG,+BAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,sDAAA;AAfH;;AAkBA;EACG,mBAAA;EACA,oBAAA;AAfH;;AAkBA;EACG,qBAAA;EACA,uBAAA;EACA,uBAAA;AAfH;;AAkBA;EACG,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;AAfH;;AAkBA;EACG,+BAAA;AAfH;;AAkBA;EACG,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;AAfH;;AAkBA;EACG,UAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAfH;AAiBG;EACG,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAfN;AAiBM;EACG,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAfT;AAkBM;EACG,oCAAA;AAhBT;;AAqBA;EACG,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAlBH;;AAqBA;EACG,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAlBH;;AAqBA;EACG,gBAAA;AAlBH;AAoBG;EACG,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAlBN;AAoBM;EACG,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AAlBT;AAoBS;EACG,sBAAA;EACA,aAAA;AAlBZ;;AAwBA;EACG,uBAAA;EACA,YAAA;EACA,oBAAA;AArBH;;AAwBA;EACG,sDAAA;AArBH;;AAwBA;EACG,wBAAA;EACA,oBAAA;AArBH;;AAwBA;EACG,kBAAA;EACA,cAAA;EACA,UAAA;AArBH;AAuBG;EACG,aAAA;AArBN;;AAyBA;EACG,kBAAA;AAtBH;;AAyBA;EACG,oBAAA;EACA,aAAA;EACA,sBAAA;AAtBH;AAwBG;EACG,eAAA;EACA,0BAAA;AAtBN;;AA0BA;EACG,aAAA;EACA,sBAAA;AAvBH;AAyBG;EACG,eAAA;EACA,0BAAA;AAvBN;;AA2BA;EACG,qBAAA;AAxBH;;AA2BA;EACG,qBAAA;EACA,yBAAA;AAxBH;;AA2BA;EACG,eAAA;EACA,cAAA;AAxBH;AA0BG;EACG,cAAA;EACA,iBAAA;AAxBN;AA2BG;EACG,WAAA;AAzBN;;AA8BA;EACG,aAAA;AA3BH;;AA8BA;EACG,eAAA;EACA,2BAAA;AA3BH;;AA+BG;EACG,uBAAA;EACA,wBAAA;EACA,iCAAA;EACA,uBAAA;AA5BN;AA8BM;EACG,sBAAA;EACA,eAAA;AA5BT;AA+BM;EACG,iBAAA;EACA,oBAAA;EACA,eAAA;AA7BT;;AAkCA;EACG,oBAAA;AA/BH;AAiCG;EACG,gBAAA;EACA,gBAAA;AA/BN;;AAmCA;EACG,mBAAA;EACA,oBAAA;EACA,YAAA;AAhCH;;AAmCA;EACG,iBAAA;AAhCH;;AAmCA;EACG,0BAAA;AAhCH;;AAmCA;EACG,UAAA;EACA,eAAA;AAhCH;;AAoCA;EACG,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;AAjCH;AAmCG;EACG,eAAA;AAjCN;AAoCG;EACG,YAAA;EACA,YAAA;AAlCN;AAqCG;EACG,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAnCN;AAsCG;EACG,+BAAA;EACA,kBAAA;AApCN;AAuCG;EACG,qCAAA;EACA,gBAAA;AArCN;AAuCO;EACE,kBAAA;AArCT;AAwCM;EACG,kBAAA;AAtCT;AAyCM;EACG,iBAAA;AAvCT;AA0CO;EACE,YAAA;EACA,kBAAA;AAxCT;AA2CO;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;AAzCT;AA4CO;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;AA1CT;AA6CO;EAEE,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AA5CT;AA+CO;EACG,4BAAA;EACA,eAAA;AA7CV;AAgDO;EACE,8BAAA;EACA,kBAAA;AA9CT;AAiDO;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA/CT;AAkDO;EACE,kBAAA;AAhDT;AAmDM;EACG,kBAAA;AAjDT;AAoDO;EACE,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAlDT;AAuDG;EACG,aAAA;EACA,sBAAA;AArDN;AAsDM;EACM,aAAA;EACA,sBAAA;AApDZ;AAsDM;EACG,aAAA;EACA,sBAAA;AApDT;AAqDS;EACG,YAAA;AAnDZ;AAyDM;EACG,gBAAA;AAvDT;AAyDO;EACE,gBAAA;AAvDT;AA2DM;EACG,gBAAA;AAzDT;AA2DO;EACE,gBAAA;AAzDT;;AA8DA;EACG,+BAAA;EACA,uBAAA;EACA,aAAA;AA3DH;;AA8DA;EACG,mBAAA;EACA,mBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,2BAAA;EACA,uBAAA;AA3DH;;AA8DA;EACG,cAAA;AA3DH;;AA8DA;EACG,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AA3DH;;AA8DA;EACG,WAAA;EACA,YAAA;AA3DH;;AA8DA;EACG,gBAAA;EACA,uBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,UAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,qBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,UAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,qBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,qBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,YAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,qBAAA;AA3DH;;AA8DA;EACG,+BAAA;EACA,UAAA;AA3DH;;AA8DA;EACG,2BAAA;AA3DH;;AA8DA;EACG,YAAA;EACA,kBAAA;AA3DH;;AA8DA;EACG,YAAA;AA3DH;;AA8DA;EACG,YAAA;AA3DH;;AA8DA;EACG,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AA3DH;;AA8DA;EACG,gBAAA;AA3DH;;AA8DA;EACG,mBAAA;AA3DH;;AA8DA;EACG,WAAA;AA3DH;;AA8DA;EACG,mBAAA;AA3DH;;AA8DA;EACG,mBAAA;EACA,oBAAA;AA3DH;;AA8DA;EACG,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;AA3DH;AA8DG;EACG,eAAA;AA5DN;AA+DG;EACG,YAAA;EACA,YAAA;AA7DN;AAgEG;EACG,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AA9DN;;AAmEA;EACG,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;AAhEH;AAmEG;EACG,qCAAA;EACA,YAAA;EACA,YAAA;AAjEN;AAoEG;EACG,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAlEN;AAqEG;EACG,iBAAA;AAnEN;AAsEG;EACG,0BAAA;AApEN;AAuEG;EACG,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;AArEN;AAwEG;EACG,uBAAA;EACA,sBAAA;EACA,mBAAA;AAtEN;AAyEG;EACG,gBAAA;AAvEN;AA0EG;EACG,oCAAA;EACA,YAAA;AAxEN;AA0EG;EACG,gBAAA;AAxEN;AA2EG;EACG,qCAAA;EACA,YAAA;AAzEN;AA2EM;;EAEG,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAzET;AA6EG;EACG,kCAAA;AA3EN;;AA+EA;EACG,0BAAA;EACA,uBAAA;AA5EH","sourcesContent":[".form-header {\n   display: flex;\n   flex-direction: row;\n   cursor: default;\n   left: 0;\n\n   mat-chip-list {\n      padding: 0;\n\n      .mat-standard-chip {\n         top: -11px;\n         font-size: 11px;\n         min-height: 10px;\n      }\n   }\n}\n\n::ng-deep .form-header .mat-chip-list-wrapper {\n   position: absolute;\n}\n\n.editable {\n   display: flex;\n   padding: 4px;\n   width: 1115px;\n   font-size: 25px;\n   color: grey;\n   margin-right: auto;\n   border: none;\n   outline: none;\n   background: transparent;\n}\n\n.editable:hover {\n   background-color: wheat;\n}\n\n.editable-new {\n   display: flex;\n   padding: 4px;\n   min-width: 230px;\n   max-width: 900px;\n   font-size: 25px;\n   color: grey;\n   margin-right: auto;\n   border: none;\n   outline: none;\n   background: transparent;\n}\n\n.editable-new:hover,\n.editable-new:focus,\n#formNameNew:hover,\n#formNameNew:focus {\n   background-color: transparent !important;\n   box-shadow: none !important;\n}\n\n.editable-new:hover {\n   background-color: wheat;\n}\n\n@media (min-width: 0px) and (max-width: 330px) {\n   .editable-new {\n      max-width: 200px;\n   }\n}\n\n@media (min-width: 330px) and (max-width: 375px) {\n   .editable-new {\n      min-width: 230px;\n   }\n}\n\n@media (min-width: 375px) and (max-width: 500px) {\n   .editable-new {\n      min-width: 245px;\n   }\n}\n\n@media (min-width: 500px) and (max-width: 667px) {\n   .editable-new {\n      min-width: 380px;\n   }\n}\n\n@media (min-width: 667px) and (max-width: 730px) {\n   .editable-new {\n      min-width: 460px;\n   }\n}\n\n@media (min-width: 730px) and (max-width: 812px) {\n   .editable-new {\n      min-width: 520px;\n   }\n}\n\n@media (min-width: 812px) and (max-width: 1024px) {\n   .editable-new {\n      min-width: 560px;\n   }\n}\n\n@media (min-width: 1024px) and (max-width: 1128px) {\n   .editable-new {\n      min-width: 730px;\n   }\n}\n\n@media (min-width: 1128px) and (max-width: 1200px) {\n   .editable-new {\n      min-width: 820px;\n   }\n}\n\n@media (min-width: 1200px) and (max-width: 1300px) {\n   .editable-new {\n      min-width: 900px;\n   }\n}\n\n@media (min-width: 1300px) and (max-width: 1360px) {\n   .editable-new-eform {\n      min-width: 950px;\n   }\n}\n\n@media (min-width: 1360px) {\n   .editable-new {\n      min-width: 1145px;\n   }\n}\n\n.form-setting {\n   display: flex;\n\n   mat-icon {\n      margin-right: 5px;\n      cursor: pointer;\n      margin-top: 2.5px;\n   }\n}\n\n.form-body {\n   // เพิ่มระยะห่างระหว่างขอบกล่องเพิ่ม section กับ footer\n   padding-bottom: 10px;\n}\n\n.f-create {\n   width: 1150px;\n   height: calc(100vh - 120px);\n   margin-left: 20px;\n}\n\n.f-control {\n   display: flex;\n}\n\n.drag-placeholder-section {\n   background: grey;\n   border: dotted 4px black;\n   min-height: 94px;\n   width: 1147px;\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.drag-placeholder-field {\n   background: rgba(0, 0, 0, 0.12);\n   border: dotted 4px #999;\n   min-height: 94px;\n   width: 100px;\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.click-active {\n   background: #bad9e8;\n   border-radius: 0.5em;\n}\n\n.mat-divider {\n   border-top-width: 2px;\n   border-top-style: solid;\n   margin: 0px 5px 0px 0px;\n}\n\n.new-field {\n   font-size: 25px;\n   text-align: center;\n   display: flex;\n   justify-content: center;\n   flex-direction: column-reverse;\n   border-width: 1px;\n   border-style: dashed;\n   border-radius: 0.5em;\n   height: 35px;\n}\n\n.new-field .field .new-table {\n   border-radius: unset !important;\n}\n\n.new-section {\n   font-size: 30px;\n   text-align: center;\n   justify-content: center;\n   flex-direction: column-reverse;\n   height: 62px;\n}\n\n.btn-strip {\n   opacity: 1;\n   top: 400px;\n   position: sticky;\n   padding: 0;\n   left: 0;\n   right: 0;\n   width: 0px;\n\n   button {\n      cursor: pointer;\n      background: none;\n      border: none;\n      outline: none;\n\n      .mat-icon {\n         color: grey;\n         border-radius: 50%;\n         position: absolute;\n         left: -5px;\n      }\n\n      :hover {\n         background-color: rgb(255, 255, 255);\n      }\n   }\n}\n\n.mat-spinner {\n   position: fixed;\n   margin-left: 50%;\n   margin-right: 50%;\n   top: 50%;\n}\n\n.load-spinner {\n   position: fixed;\n   width: 100%;\n   height: 100%;\n   top: 0;\n   left: 0;\n   right: 0;\n   bottom: 0;\n   background-color: rgba(0, 0, 0, 0.5);\n   z-index: 2;\n   cursor: wait;\n}\n\n.section-preview, .field-preview {\n   max-width: 250px;\n\n   button {\n      text-align: left;\n      max-width: 250px;\n      background-color: wheat;\n      color: grey;\n\n      .inner-preview {\n         white-space: nowrap;\n         max-width: 250px;\n         overflow: hidden;\n         text-overflow: ellipsis;\n         border: 1px solid wheat;\n\n         mat-icon {\n            vertical-align: middle;\n            margin: 0.2em;\n         }\n      }\n   }\n}\n\n.cdk-drop-list-dragging {\n   background-color: wheat;\n   opacity: .5;\n   border-radius: 0.5em;\n}\n\n.cdk-drop-list-dragging .cdk-drag {\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.form-valid {\n   border: 1px solid salmon;\n   border-radius: 0.5em;\n}\n\n.error-tooltip {\n   position: absolute;\n   margin: -4.5px;\n   color: red;\n\n   mat-icon {\n      margin: -10px;\n   }\n}\n\n.hide-load {\n   visibility: hidden;\n}\n\n.field-container {\n   pointer-events: none;\n   display: flex;\n   flex-direction: column;\n\n   label {\n      font-size: 11px;\n      padding: 1px 10px 1px 10px;\n   }\n}\n\n.field-container-f-table {\n   display: flex;\n   flex-direction: column;\n\n   label {\n      font-size: 11px;\n      padding: 1px 10px 1px 10px;\n   }\n}\n\n.space-pre {\n   white-space: pre-wrap;\n}\n\n.space-break {\n   word-break: break-all;\n   white-space: break-spaces;\n}\n\n:host .mat-menu-panel {\n   min-height: 0px;\n   min-width: 0px;\n\n   .mat-menu-content {\n      padding-top: 0;\n      padding-bottom: 0;\n   }\n\n   .mat-menu-item {\n      width: auto;\n   }\n}\n\n\n.content-style {\n   display: flex;\n}\n\n.input-label {\n   font-size: 11px;\n   padding: 10px 10px 1px 10px;\n}\n\n.menu-item {\n   button {\n      height: auto !important;\n      display: flex !important;\n      flex-direction: column !important;\n      padding: 4px !important;\n\n      mat-icon {\n         margin: 0px !important;\n         font-size: 18px;\n      }\n\n      span {\n         margin-top: -13px;\n         margin-bottom: -13px;\n         font-size: 10px;\n      }\n   }\n}\n\n.signature {\n   margin-bottom: 7.7px;\n\n   img {\n      max-height: 50px;\n      max-width: 220px;\n   }\n}\n\n.cut-active {\n   background: #bad9e8;\n   border-radius: 0.5em;\n   opacity: 0.5;\n}\n\n.always-right {\n   text-align: right;\n}\n\n::ng-deep .choice-field-body .mat-form-field-label {\n   font-size: 14px !important;\n}\n\n::ng-deep .choice-field-body .mat-form-field-flex {\n   width: 95%;\n   margin-left: 2%;\n}\n\n\n.choice-field-body-table {\n   display: flex;\n   flex-direction: column;\n   overflow: auto;\n   height: auto;\n   word-wrap: break-word;\n\n   .mat-form-field {\n      font-size: 14px ;\n   }\n\n   select {\n      height: 22px;\n      cursor: move;\n   }\n\n   select:disabled {\n      border-width: 1px;\n      border-color: rgba(118, 118, 118, 0.3);\n      background: #f8f8f8;\n      border-radius: 2px;\n      border-style: groove;\n   }\n\n   .mat-form-field-appearance-outline .mat-form-field-outline {\n      color: rgba(118, 118, 118, 0.3);\n      border-radius: 5px;\n   }\n\n   .choice-layout-0, .choice-layout-1 {\n      margin: 0px 1px 7.5px 10px !important;\n      overflow: hidden;\n\n       .mat-radio-button~.mat-radio-button {\n         margin-right: 20px;\n      }\n\n      .mat-radio-button:first-child {\n         margin-right: 20px;\n      }\n\n      .mat-radio-container {\n         align-self: start;\n      }\n\n       .mat-radio-disabled, .mat-radio-disabled .mat-radio-label {\n         cursor: move;\n         margin-top: .25px;\n     }\n\n       .mat-radio-outer-circle {\n         height: 18px !important;\n         width: 18px !important;\n         top: 3px !important;\n         border-width: 1px !important;\n       }\n\n       .mat-radio-inner-circle {\n         height: 18px !important;\n         width: 18px !important;\n         top: 3px !important;\n     }\n\n       .mat-radio-button.mat-radio-disabled .mat-radio-label-content {\n\n         color : rgba(0, 0, 0, 0.54);\n         padding-left: 8px;\n         margin-top: 2px;\n         word-break: break-all;\n       }\n\n       .mat-checkbox-inner-container {\n          margin-right: 0px !important;\n          margin-top: 5px;\n       }\n\n       .mat-radio-label {\n         white-space: normal !important;\n         margin-bottom: 5px;\n       }\n\n       .mat-checkbox-layout {\n         white-space: normal !important;\n         margin: 1px;\n         cursor: move;\n         margin-top: -1px;\n       }\n\n       .mat-checkbox ~ .mat-checkbox {\n         margin-right: 20px;\n      }\n\n      .mat-checkbox:first-child {\n         margin-right: 20px;\n      }\n\n       .mat-checkbox-label {\n         margin-top: 3px;\n         word-break: break-all;\n         padding-left: 10.5px;\n         margin-bottom : 5px;\n         line-height: inherit;\n       }\n\n   }\n\n   .choice-layout-1 {\n      display: flex;\n      flex-direction: column;\n      .mat-radio-group {\n            display: flex;\n            flex-direction: column;\n         }\n      section {\n         display: flex;\n         flex-direction: column;\n         .mat-checkbox-disabled {\n            cursor: move;\n         }\n      }\n   }\n\n   .choice-box-field-three {\n      .mat-radio-button.mat-radio-disabled .mat-radio-label-content {\n         max-width: 327px;\n       }\n       .mat-checkbox-label {\n         max-width: 309px;\n       }\n   }\n   .choice-box-field-two {\n      .mat-radio-button.mat-radio-disabled .mat-radio-label-content {\n         max-width: 510px;\n       }\n       .mat-checkbox-label {\n         max-width: 500px;\n       }\n   }\n}\n\n.f-table {\n   border-radius: unset !important;\n   width: 250px !important;\n   flex: 0 0 25%;\n}\n\n.div-table {\n   margin-bottom: 10px;\n   padding-right: 12px;\n}\n\n.new-table {\n   border-radius: unset !important;\n   margin-top: 18px !important;\n   height: 22px !important;\n}\n\n.space-break {\n   color: #88808D;\n}\n\n.field-table {\n   font-size: 25px;\n   text-align: center;\n   display: flex;\n   justify-content: center;\n   flex-direction: column-reverse;\n   border-width: 1px;\n   border-radius: 0.5em;\n   height: 60px;\n   color: #b2b2b8;\n}\n\n.field-table > .field-set {\n   width: 100%;\n   height: 100%;\n}\n\n.field-header-table {\n   min-height: 17px;\n   margin: 5px 5px 1px 2px;\n}\n\n.t-table {\n   border-radius: unset !important;\n   width: calc(100% / 4);\n}\n\n.table-few {\n   border-radius: unset !important;\n   width: calc(100% / 3);\n}\n\n.table-4 {\n   border-radius: unset !important;\n   width: calc(100% / 5);\n}\n\n.table-5 {\n   border-radius: unset !important;\n   width: calc(100% / 6);\n}\n\n.table-6 {\n   border-radius: unset !important;\n   width: calc(100% / 7);\n}\n\n.table-7 {\n   border-radius: unset !important;\n   width: calc(100% / 8);\n}\n\n.table-8 {\n   border-radius: unset !important;\n   width: calc(100% / 9);\n}\n\n.table-9 {\n   border-radius: unset !important;\n   width: calc(100% / 10);\n}\n\n.name-field-body {\n   overflow: hidden !important;\n}\n\n.input-table {\n   height: 22px;\n   margin-right: -1px;\n}\n\n.div-plus {\n   width: 100px;\n}\n\n.div-maxTable {\n   height: 75px;\n}\n\n.text-number {\n   text-align: left;\n   margin-left: 3px;\n   font-size: 11px;\n   float: left;\n   color: #88808D;\n   margin-top: 5px;\n}\n\n.max-head-table {\n   margin-top: 10px;\n}\n\n.field-plus {\n   margin-bottom: 16px;\n}\n\n.style-left {\n   float: left;\n}\n\n.over-table:hover {\n   background: #F2F2F2;\n}\n\n.click-active-table {\n   background: #bad9e8;\n   border-radius: 0.5em;\n}\n\n.radio-field-body-table {\n   display: flex;\n   flex-direction: column;\n   overflow: auto;\n   height: auto;\n   word-wrap: break-word;\n\n\n   .mat-form-field {\n      font-size: 14px ;\n   }\n\n   select {\n      height: 22px;\n      cursor: move;\n   }\n\n   select:disabled {\n      border-width: 1px;\n      border-color: rgba(118, 118, 118, 0.3);\n      background: #f8f8f8;\n      border-radius: 2px;\n      border-style: groove;\n   }\n\n}\n\n.radio-field-body {\n   display: flex;\n   flex-direction: column;\n   overflow: auto;\n   height: auto;\n   word-wrap: break-word;\n   z-index: 0;\n\n\n   select {\n      margin: 0px 10px 10px 10px !important;\n      height: 23px;\n      cursor: move;\n   }\n\n   select:disabled {\n      border-width: 1px;\n      border-color: rgba(118, 118, 118, 0.3);\n      background: #f8f8f8;\n      border-radius: 2px;\n      border-style: groove;\n   }\n\n   .mat-radio-button ~ .mat-radio-button {\n      margin-left: 20px;\n   }\n\n   .mat-radio-button.mat-radio-disabled .mat-radio-label-content {\n      color: rgba(0, 0, 0, 0.54);\n   }\n\n   .mat-radio-outer-circle {\n      height: 18px !important;\n      width: 18px !important;\n      top: 3px !important;\n      border-width: 1px !important;\n   }\n\n   .mat-radio-inner-circle {\n      height: 18px !important;\n      width: 18px !important;\n      top: 3px !important;\n   }\n\n   .mat-checkbox-layout {\n      margin-top: -1px;\n   }\n\n   .radio-body {\n      margin: 0px 1px 10px 10px !important;\n      cursor: move;\n   }\n   .radio-slide{\n      margin-top: -1px;\n   }\n\n   .radio-body-1 {\n      margin: 0px 10px 10px 10px !important;\n      cursor: move;\n\n      .mat-radio-disabled,\n      .mat-radio-disabled .mat-radio-label {\n         cursor: move;\n         margin-top: -1px;\n         padding: 1.2px;\n         padding-left: 0px;\n         padding-right: 0px;\n      }\n   }\n\n   .ct {\n      justify-content: center !important;\n   }\n}\n\n.name-field-body .field-header-table {\n   font-size: 14px !important;\n   margin: 5px 5px 1px 0px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
